import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';


function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object; }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
    var ret = [];
    for (var i = 0; i < n; i++)
        ret.push(v instanceof Object ? clone(v) : v);
    return ret;
}

function bool(s) {
    if (typeof (s) == 'boolean') return s;
    if (!defined(s) || s === null) return false;
    if (typeof (s) == 'number') return s > 0;
    if (s.match(/^y/i)) return true;
    return false;
}

function sbool(v) {
    return ['No', 'Yes'][v];
}

var companyList = [];
function getCompanies(callback) {
    if (companyList.length) callback(companyList)
    window.post('find_companies', { match: {active:true} }, function (res) {
        if (res.status) companyList = res.data.records;
        console.log('companyList', companyList);
        callback(companyList);
    })
}



function UserRole(prop) {

    var global = window.GlobalVars;
    var tab;
    var userEmail = null;





    useEffect(function (a) {
        $('#topbuttons').html('');

        var roles = global.userRoles;

        var desc = {
            // selectMode: userSelect,
            selectId: 'email',
            title: 'Select one of the following roles',
            columns: {
                // _id: 'Id',
                // name: 'Name',
                companyName: 'Company',
                priv: 'Priv.',
                projectName: 'Project',
                datasetName: 'Dataset',
                lastLogin: 'Last Login',
                // delete: '',
            },
            filter: true,
            search: true,
            sort: true,
            // sortAlias: { lastLoginDelta: 'lastLogin' },
            // initialSort: 'lastLogin',
            // initialSortDir: -1,
            pageSize: 10,
            // noFilter: ['lastLogin'],
            noSearch: null,
            noSort: null,
            centerCol: true,
            format: tabler.formatString,
            formatCol: {
                priv: tabler.formatPriv,
                active: tabler.formatActive,
                lastLogin: tabler.formatTimeAgo,
                projectName: frm.smallerText,
                datasetName: frm.smallerText,
            },
            forceType: { lastLogin: 1, active: 1, created: 1 },
            headerClick: 'filter',
            // clickCol: ['stateLabel','source'],
        }
        window.post('find_users', {match:{email:window.GlobalVars.userEmail}}, res => {
            var user =  res.data.records[0];
            tab = tabler.table($('#documentlist'), desc);
            user.roles.forEach(r => {
                // r.delete = '<i class="fa fa-close worker-del"></i>';
                // r.projectName = r.project ? user.projects.find( p => p.id == r.project ).name : '';
                tab.addRow(r, function (col, row) {
                    // r.priv = (r.priv || '').split(',')
                    console.log('tabler click', r._id, col, row[col], row)

                    window.post('set_user_role', {roleId: row._id}, res => {
                        var data = res.data;
                        console.log( 'session', data );
                        global.userPriv = frm.arr2Bool((data.priv));
                        global.userCompany = data.company;
                        global.userCurrentRole = data.currentRole;
                        global.usersupervisedProject = data.supervisedProject;
                        global.usersupervisedDataset = data.supervisedDataset;
                        console.log( 'priv', global.userPriv )
                        window.saveSession( function(){
                            window.goPage('')
                        });

                    })
                })
            })
            tab.draw();
            console.log('desc', desc, 'tabler', tabler.formatString)
        })

    });

    return (
        <div fluid="md p-0" className="maincontent">
            <div id="topbuttons"></div>
            <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
            </Table>
        </div>
    )
}

export default UserRole
